import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { FormTable } from '../../interfaces/form.interface';

@Component({
    selector: 'app-reactive-form-table',
    standalone: false,
    templateUrl: './form-table.component.html',
    styleUrls: ['./form-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReactiveFormTableComponent {
    @Input({ required: true }) public table!: FormTable;
}
